<template>
    <div class="about_menu_top  textalign_left">
        <div style="background: #fff;max-width: 1920px;margin: 0 auto;"  class="ms-controller">
            <div style="margin: 0 auto;">
                <div style="height: 9000px;background: url('https://p1.fishqc.net/lrwI5uffNE5rMvhCepu8Cn14leN_') center center no-repeat;background-size:auto  100%;padding-top: 595px;box-sizing: border-box;">
                    <div class="contain_2022_315" style="width:1010px;margin:0 auto;display:block;position: relative;font-family: SourceHanSansSC, SourceHanSansSC;font-weight: 500;font-size: 32px;color: #FEFEFE;line-height: 48px;text-align: center;">
                        <div style="width:795px;margin:0 auto;padding-bottom:72px;box-sizing: border-box;">诚信315，省心更放心。小鱼用科学测评为你做保障，测评各类日常消费品，让你的315多一份安心！</div>
                        
                        <div>
                            <div v-for="val in productDatas" class="">
                                <img :src="val.titleImg" class="_2024_title">
                                <div style="text-align: center;">
                                    <div class="_2024_desc" v-html="val.desc"></div>
                                </div>
                                <div :class="['_2024_315_productcontain',value.boximg]" v-for="value  in val.productarr">
                                    <div class="_2024_315_productdesc">{{value.desc}}</div>
                                    <div style="text-align: center;padding:0 30px;">
                                        <div v-for="item in value.product" class="_2024_315_box display_flex" @click="toproductdetail(item.type,item.id)">
                                            <div class="productImg" :style="{backgroundImage: 'url('+ item.img + ')'}">
                                                <div>
                                                    <img src="https://p1.fishqc.net/FlEW9ExBKGSChb3UmL1_ihEZR-Nj" class="greenIcon" v-if="item.id == 'sUOufi6j_cK_NwqCK8hI6g'">
                                                    <img v-else src="https://p1.fishqc.net/FooMAleWAOXTrBgw2AHWIIjiDZL4" class="greenIcon">
                                                </div>
                                            </div>
                                            <div style="text-align: left;flex:1;box-sizing: border-box;padding-left: 16px;" class="display_flex justify-content_flex-justify derection-column">
                                                <div>
                                                    <div class="brand_315">{{item.brand}}</div>
                                                    <div class="producttitle_315" v-html="item.title">{{item.title}}</div>
                                                    <div v-if="item.effect" style="padding-top: 10px;box-sizing: border-box;">
                                                        <img src="https://p1.fishqc.net/Fu_RDE3tRhCtzoIy8iJWNqcjn27I">
                                                    </div>
                                                </div>
                                                <div>
                                                    
                                                    <div class="tips_315">{{item.tips}}</div>
                                                    <div class="address_315">品牌所在地：{{item.address}}</div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                               <!--  <div class="productcontain_315">
                                    <div v-for="item in val.productarr" class="padding_top_1">
                                        <img :src="item.title">
                                        <div style="text-align: center;">
                                            <div class="producttype_desc" v-html="item.desc"></div>
                                        </div>
                                        <div class="display_flex justify-content_flex-justify ">
                                            <div v-for="productItem in item.product" class="productbox_315 display_flex justify-content_flex-justify" @click="toproductdetail(productItem.type,productItem.id)">
                                                <div class="productImg" :style="{backgroundImage: 'url('+ productItem.img + ')'}">
                                                    <div>
                                                        <img src="https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I" class="greenIcon">
                                                    </div>
                                                </div>
                                                <div style="text-align: left;flex:1;box-sizing: border-box;padding-left:16px;" class="display_flex justify-content_flex-justify derection-column">
                                                    <div>
                                                        <div class="brand_315">{{productItem.brand}}</div>
                                                        <div class="producttitle_315" v-html="productItem.title">{{productItem.title}}</div>
                                                        <div v-if="productItem.effect" style="padding-top: 10px;box-sizing: border-box;">
                                                            <img src="https://p1.fishqc.net/Fu_RDE3tRhCtzoIy8iJWNqcjn27I">
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div class="address_315">品牌所在地：{{productItem.address}}</div>
                                                        <div class="tips_315">{{productItem.tips}}</div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div> -->
                            </div>
                            

                            <div style="padding:74px 0 42px"> 
                                <img src="https://p1.fishqc.net/Fun1POy99hiCtXLnVHVNSKSeDezw" alt="" style="margin:0 auto">
                            </div>
                            <div style="padding-bottom: 80px;">
                                <img src="https://p1.fishqc.net/Fo9elV_1oKs6JY4TE4Khiw8su3j_" alt="" style="margin:0 auto">
                            </div>
                            <div>
                                <img src="https://p1.fishqc.net/FsMKR4iBRNzctZcDAh35TiZIkdr9" alt="" style="margin:0 auto">
                            </div>

                            <div style="padding:90px 0 0px">
                                <img src="https://p1.fishqc.net/FiHl3F7Yplem1D0xVDUJKZjVwTwx" alt="">
                            </div>
                        </div>

                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain {
    font-size: 0;
}

.mumcontain{
    width: 1054px;
    margin:0 auto;
    display: block;
    text-align: center;
    /*padding-top: 1937px;*/
    
}
.muntitle{
    font-size:32px;
    font-family:Songti SC;
    font-weight:900;
    color:rgba(255,255,255,1);
    line-height:43px;
    text-shadow:0px 3px 8px rgba(255,117,131,0.3);
    padding:0 20px;
    vertical-align: middle;
}

.verticalalign-middle{
    vertical-align: middle;
}

.munbox{
    width:100%;
    background:#FFF7F5;
    border-radius:24px;
    padding:0 32px 60px;
    margin-bottom: 60px;

}


.munbox:last-child{
    margin-bottom: 0px;
}
.producttype{
    display:inline-block;
    width:178px;
    height:48px;
    line-height: 48px;
    color:#fff;
    font-size:24px;
    text-align:center;
    border-bottom-left-radius:42px;
    border-bottom-right-radius:42px;
    background: -webkit-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -o-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -moz-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -ms-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -webkit-gradient(linear, 0% 100%, from(rgba(254,99,72,1)), to(rgba(255,139,119,1)));
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(254,99,72,1)), color-stop(100%,rgba(255,139,119,1)));
    background:linear-gradient(0deg,rgba(254,99,72,1),rgba(255,139,119,1));
    box-shadow: 0px 0px  8px #FFAD9D;
}

.gradient{
    background: #000000;
    background: -moz-linear-gradient(top,  #000000 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#000000), color-stop(100%,#ffffff));
    background: -webkit-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -o-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -ms-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: linear-gradient(to bottom,  #000000 0%,#ffffff 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#ffffff',GradientType=0 );
}
.dec{
    padding:24px 0;
    box-sizing:border-box;
    color:#444a46;
    font-size:24px;
    line-height: 24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
}

.dec-text{
    font-size:18px;
    color:#494947;
    line-height:30px;
    text-indent:3px;
    text-align:left;
    padding:20px 32px;
    background-color:#fff;
    border-radius:20px;
    position:relative;
    margin-bottom: 35px;
    
}
.tips{
    width: 174px;
    height:36px;
    line-height:36px;
    background-color:#45ccbe;
    box-sizing:border-box;
    position:absolute;
    bottom:-20px;
    right:0;
    border-bottom-right-radius:20px;
    border-top-left-radius:20px;
    text-align: center;
    
}
.tipstext{
    display:inline-block;
    font-size:24px;
    color:#fff;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(225,251,248,1);
}

.productdetailcontain{
    width: 273px;
    margin-right: 60px;
    display: inline-block;
    background-color: #fff;
    border-radius:24px;
    height: 402px;
    vertical-align: top;
    /*margin-bottom: 32px;*/
    cursor: pointer;
    padding:0 40px 0;
    box-sizing: border-box;
    box-shadow: 0px 0px 24px rgba(255,117,131,0.06);

}
.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
}

.productdetailcontain:nth-of-type(3n){
    margin-right: 0px;
}

.imgcontain{
    width:100%;
    height: 100%;
    display: inline-block;
    text-align:center;
    position: relative;
    overflow: hidden;
}
.center{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
}
.greenfish{
    position:absolute;
    right:14px;
    bottom:0px;
}
.class1{
    height: 130%;
    /*width:238px;*/
}
.class2{
    height: 100%;
    /*width:120px;*/
}
.class3{
    height: 100%;
    /*width:157px;*/
}
.class4{
    /*width:218px;*/
    height: 114%;
}
.class5{
    /*width:140px;*/
    height: 100%;
}
.class6{
    /*width:106px;*/
    height: 100%;
}
.class7{
    /*width:119px;*/
    height: 100%;
}
.class8{
    /*width:200px;*/
    height: 100%;
}
.class9{
    /*width:200px;*/
    height: 120%;
}
.class10{
    /*width:210px;*/
    height: 120%;
}

.class11{
    /*width:82px;*/
    height: 100%;
}
.class12{
    /*width:110px;*/
    height: 100%;

}
.class13{
    /*width:172px;*/
    height: 100%;
}
.class14{
    /*width:128px;*/
    height: 100%;
}
.class15{
    /*width:76px;*/
    height: 100%;

}
.class16{
    /*width:158px;*/
    height: 112%;
}

.flex-one{
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}
.brandcover{
    padding:20px 0 10px;
}

.band{
    
    font-size:24px;
    line-height: 26px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(80,79,75,1);
}

.title{
    font-size:18px;
    line-height: 24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
    padding-bottom: 20px;
}

.detail-tips{
    padding:0 12px;
    height:30px;
    background:rgba(210,242,238,1);
    border-radius:12px 0px 12px 0px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(68,204,189,1);
    line-height: 30px;
    display:inline-block;
    text-align: center;

}
.address{
    padding-top: 16px;
    font-size:16px;
    line-height: 16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(121,121,121,1);
}

.techcontain{
    width: 1054px;
    margin:0 auto;
    display: block;
    text-align: center;
}
.heightclass1{
    height: 392px;
}
.heightclass2{
    height: 392px;
    margin-right:0;
}
.heightclass3{
    height: 470px;
}

.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    height: 256px;
}

.derection-column{
    flex-direction: column;
    -webkit-flex-direction: column;
}

.display_flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}

/*.display_flex > *{
     display: block;
 }*/
.display_inline-flex {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: -webkit-inline-flex;
    display: inline-flex;
}


/*伸縮流方向*/
.flex-direction_column {
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
}

/*主軸對齊*/
.justify-content_flex-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}

.justify-content_flex-end {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
}

.justify-content_flex-justify {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}

/*側軸對齊*/
.align-items_flex-start {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
}

.align-items_flex-end {
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}

.align-items_center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.align-items_baseline {
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    -webkit-align-items: baseline;
    align-items: baseline;
}

.align-items_space_between {
    -webkit-box-align: space-between;
    -ms-flex-align: space-between;
    -webkit-align-items: space-between;
    align-items: space-between;
}

.horizontal-between {
    justify-content: space-between;
    -webkit-justify-content: space-between;
}

/*伸縮性*/
.flex_auto {
    -webkit-box-flex: 1;
    -ms-flex: auto;
    -webkit-flex: auto;
    flex: auto;
}

.flex_1 {
    width: 0;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}

.flex_2 {
    width: 0;
    -webkit-box-flex: 2;
    -ms-flex: 2;
    -webkit-flex: 2;
    flex: 2;
}


.flex-wrap_wrap {
    flex-wrap: wrap;
}
.padding-top-495 {
    padding-top: 495px;
}

.double11_head {
    width: 1000px;
    box-sizing: border-box;
    font-size: 26px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FEAE50;
    line-height: 48px;

    background-color: #fff;
    text-align: center;
    letter-spacing: 2px;
    position: relative;
    z-index: 2;
    margin: 0 auto;
}

.double11_back {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0);
    width: 958px;
    height: 70px;
    background-image: url('http://p1.fishqc.net/Fnbl0MTCI_lcZufbh51TuOICg5-u');
    background-repeat: no-repeat;
    background-position: center center;

}

.font-weight-bold {
    font-weight: bold;


}

.padding-top-46 {
    padding-top: 46px;
    text-align: center;
}

.double11_desc1 {
    padding-top: 14px;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
}

.double11_bg {
    width: 1078px;
    background-image: url('http://p1.fishqc.net/FrSI1Mebdl0WDMyxfdhmR0g89YMC');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
}

.double11_list {
    width: 1000px;
    margin-top: 82px;
    background-color: #fff;
    padding: 26px 30px 50px;
    box-sizing: border-box;
    z-index: 2;
    display: inline-block;
    position: relative;
}

.shadow-bottom {
    position: absolute;
    bottom: 30px;
    left: 0;
    z-index: 1
}

.double11_txt {
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #544F4D;
    text-align: center;
    line-height: 48px;
    text-align: left;
}

.double11_item {
    width: 454px;
    height: 161px;
    background: #FFFFFF;
    border: 1px solid #EEEAF0;
    margin-right: 27px;
    display: inline-block;
    margin-top: 20px;
    cursor: pointer;
}

.double11_item:nth-of-type(2n) {
    margin-right: 0;
}

.double11_item:nth-of-type(1) {
    margin-top: 6px;
}

.double11_item:nth-of-type(2) {
    margin-top: 6px;
}

.double11_list2 {
    margin-top: 92px;
    line-height: 48px;
    text-align: left;
}

.double11_list2 .double11_txt {
    text-align: left
}

.padding-top-110 {
    padding-top: 110px;
    text-align: center;
}

.double11_item_left {
    width: 160px;
    height: 100%;
    position: relative;
    display: inline-block;
    vertical-align: top;
}

.double11_item_left .productimg {
    width: 140px;
    position: absolute;
    left: 40%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.double11_item_right {
    width: 280px;
    height: 100%;
    display: inline-block;
    position: relative;
    padding-right: 20px;
    box-sizing: border-box;

}

.double11_item_right .title {
    padding-top: 25px;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #3F3E3A;
    line-height: 30px;
    padding-bottom: 18px;
    text-align: left;
}

.double11_address {

    font-size: 17px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #666666;
    line-height: 17px;
}

.double11_label {
    width: 98px;
    height: 30px;
    background: #FDF2E3;
    text-align: center;
    line-height: 30px;

    font-size: 17px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #FEAE82;
}

.greenfish {
    width: 64px;
    height: 64px;
    position: absolute;
    bottom: 10px;
    right: 10px;
}

.double_top_title {
    position: absolute;
    top: -52px;
    left: 50%;
    transform: translate(-50%, 0);
}
/**/
.descbox{
    height: 138px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 4px #93eee0;
    border-radius: 24px;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #3844BA;
    line-height: 44px;
    padding: 24px 130px 0 100px;
    box-sizing: border-box;
    text-align: left;
}

.padding_top_60{
    padding-top: 60px;
    box-sizing: border-box;
}

.typeItem{
    height: 138px;
    background: #355CD0;
    box-shadow: 0px 0px 6px 4px #93eee0;
    border-radius: 24px;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #FEFFFF;
    line-height: 44px;
    text-align: left;
    padding:24px 116px 0 102px;
    box-sizing: border-box;
    position: relative;
}
.typeItem_bg{
    position: absolute;
    width:1116px;
    height: 121px;
    background: url('http://p1.fishqc.net/FgzbpmuZst-kw-yHrPcfK94rVFyt');
    background-size: contain;
    background-repeat: no-repeat;
    left: -56px;
    top: -78px;
}
    
.productItem_315{
    background: #EDFFFC;
    box-shadow: 0px 0px 8px 1px rgba(83, 116, 215, 0.29);
    border-radius: 24px;
    position: relative;
    margin-top: 78px;
    padding-top:52px;
    box-sizing: border-box;
    box-shadow: 0px 0px 12px 20px #24409314;
}

.productItem_type_title{
    width: 335px;
    height: 62px;
    background-image: url('http://p1.fishqc.net/FsFAr9gnZ3fl22TIaTazjL7T3LRS');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    line-height: 62px;
    text-align: center;
    position: absolute;
    left:50%;
    top:-31px;
    transform: translate(-50%,0);
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #3844BA;
}

.productItem_type_desc{
    width: 936px;
    margin:0 auto 30px;
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 0px rgba(115, 228, 209, 0.21);
    border-radius: 16px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    line-height: 30px;
    padding:18px 32px 14px;
    box-sizing: border-box;
    text-align: left;
    box-shadow: 0px 0px 12px 5px #73e4d12e;
}

.double12_product{
    width: 454px;
    height: 254px;
    background: #FFFFFF;
    box-shadow: 0px 1px 8px 0px rgba(205, 247, 218, 0.7);
    border-radius: 24px;
    cursor: pointer;
    box-shadow: 0px 0px 12px 5px #73e4d12e;
}

.double12_producttxt{
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #58BA96;
    text-align: left;
    padding-top: 40px;
    box-sizing: border-box;

    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #3844BA;
    line-height: 26px;
}

.double12_address{

    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    line-height: 43px;
}

.double12_img{
    width: 154px;
    width: 200px;
    height: 254px;
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;

}
.tips_padding{
    padding-top: 50px;
    padding-bottom: 24px;
    box-sizing: border-box;
}
.double12_tips{
    line-height: 16px;
    font-size: 16px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #44CCBD;
    padding:6px 14px;
    box-sizing: border-box;
    background: #D2F2EE;
    opacity: 0.7;
    border-radius: 16px 0px 16px 0px;
    
}

.decclass{
    width: 880px;
}
.decclass1{
    width: 660px;
}
.greenfish{
    width: 88px;
    height: 88px;
    position: absolute;
    bottom: 24px;
    right: 0px;

}
.producttxt_name{
    font-size: 18px;
    line-height: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    padding-top: 10px;
    box-sizing: border-box;
}

.product_img{
    width: 154px;
    height: 205px;
    margin-top: 30px;
    margin-left:20px;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
}

/*315*/
.contain_2022_315{
    .title_315{
        width: 1048px;
        font-size: 34px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 56px;
        margin: 0 auto;
        padding-bottom: 90px;
        box-sizing: border-box;
    }

    .productcontain_315{
        width: 1009px;
        height: 1215px;
        background: url('https://p1.fishqc.net/Fv9Pw0Ex63QCA5mm8cLrgUtJpg0D') center center no-repeat;
        background-size: contain;
        padding: 52px 18px 0;
        box-sizing: border-box;

    }

    .productcontain_315_second{
        width: 1009px;
        height: 1215px;
        background: url('https://p1.fishqc.net/Fv9Pw0Ex63QCA5mm8cLrgUtJpg0D') center center no-repeat;
        background-size: contain;
        padding: 52px 18px 0;
        box-sizing: border-box;
    }

    ._2024_desc{
        width: 871px;
        font-family: 'SourceHanSansSC','SourceHanSansSC';
        font-weight: 400;
        font-size: 32px;
        color: #FEFEFE;
        line-height: 56px;
        text-align: center;
        font-style: normal;
        text-transform: none;
        margin:0 auto;
        padding-bottom:64px;

    }

    .box_paddingtop{
        padding-top:64px;
        box-sizing: border-box;
        &:first-child{
            padding-top: 0;
        }
    }

    .padding_top_1{
        padding-top:52px;
        box-sizing: border-box;
        &:first-child{
            padding-top:0;
        }
    }

    .padding_top_{
        padding-top:52px;
        box-sizing: border-box;
        &:first-child{
            padding-top:0;
        }
    }

    .title_3{
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #FEFEFE;
        line-height: 70px;
        text-shadow: 1px 2px 3px #76AFC4;
        padding-top: 34px;
        box-sizing: border-box;
    }

    .producttype_desc{
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
        text-align: left;
        margin:0 auto;
/*        width: 910px;*/
        padding-top:30px;
        padding-bottom:26px;
        box-sizing: border-box;
        display: inline-block;
    }

    .productbox_315{
        width: 478px;
        height: 226px;
        background: url('https://p1.fishqc.net/FlcbSZX9iYo0rivEHSmJlBRAkOkd') center center no-repeat;
        background-size: contain;
        cursor: pointer;
        padding:12px 0 12px 12px;
        box-sizing: border-box;
    }

    .padding_30_315{
        padding: 26px 30px;
        box-sizing: border-box;
    }
   
}

.contain_top{
    padding-top:70px;
    box-sizing: border-box;

}


._2024_title{
    width: 448px;
    height: 78px;
}



._2024_315_productcontain{
    margin:0 auto;
    margin-bottom:70px;
    padding:124px 0px 20px;
    box-sizing: border-box;
    &.bg1{
        width:991px;
        height: 860px;
        background: url('https://p1.fishqc.net/FrwHyOXD0xryW2-fRukESwDsFFa5') center center no-repeat;
        background-size: contain;

    }

    &.bg2{
        width:989px;
        height: 872px;
        background: url('https://p1.fishqc.net/FjaRFK9FSJJbdXVCk-mR0O4Wf2Cb') center center no-repeat;
        background-size: contain;

    }


    &.bg3{
        width:989px;
        height: 857px;
        background: url('https://p1.fishqc.net/FuerEPF5lzZ3Wi0iDekekGJSvcyH') center center no-repeat;
        background-size: contain;
        margin-bottom:94px;

    }


    &.bg4{
        width:989px;
        height: 867px;
        background: url('https://p1.fishqc.net/FrjC6OYmVs-waRb9bmKN26az4e5J') center center no-repeat;
        background-size: contain;

    }

    &.bg5{
        width:989px;
        height: 857px;
        background: url('https://p1.fishqc.net/Ftn4tz5TWUgzB7hsoI6Z-iTyRrBA') center center no-repeat;
        background-size: contain;
        margin-bottom:0;

    }

   ._2024_315_productdesc{
        width: 884px;
        font-family: 'SourceHanSansSC','SourceHanSansSC';
        font-weight: 400;
        font-size: 25px;
        color: #252525;
        line-height: 50px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin: 0 auto;
        padding-bottom: 40px;
   }

   ._2024_315_box{
        width:460px;
        height: 256px;
        background: url('https://p1.fishqc.net/FpI_WsXVxyxfGYz5oByxuc8BmJmj') center center no-repeat;
        background-size: contain;
        margin-right:8px;
        margin-bottom:30px;
/*        display: inline-block;*/
        float: left;
        cursor: pointer;
        padding:15px;
        box-sizing: border-box;
        &:nth-of-type(even){
            margin-right: 0;
        }
   }



    .productImg{
        width: 156px;
        height: 224px;
        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
        position: relative;
    }

    .brand_315{
        /*font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 24px;
        padding-top:10px;*/

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #2B2B2B;
        line-height: 33px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        padding-top: 6px;
    }
    .producttitle_315{
        /*font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 24px;*/

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #2B2B2B;
        line-height: 33px;
        text-align: left;
        font-style: normal;
        text-transform: none;
    }
    .tips_315{
        /*background: #0631d9;
        border-radius: 15px;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 30px;
        display: inline-block;
        padding:0 12px;*/
        box-sizing: border-box;

      /*  background: #6241D4;
        box-shadow: inset 2px 0px 6px 0px #BBA7FF;
        border-radius: 12px 0px 12px 0px;
        */
        text-align:center;
        width: 128px;
        height: 38px;
        line-height: 38px;
        background: #6241D4;
        box-shadow: inset 3px 0px 9px 0px #BBA7FF;
        border-radius: 16px 0px 16px 0px;
        margin-bottom: 20px;

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #FEFEFE;
    }

    .address_315{
        /*font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #FFFFFF;
        line-height: 18px;*/

        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #2B2B2B;
        line-height: 33px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        padding-bottom:16px;
    }

    .greenIcon{
        width: 98px;
        height: 95px;
        position: absolute;
        bottom: 0px;
        left:-8px;
    }


    
}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            
            productDatas:[
                    {
                        titleImg:'https://p1.fishqc.net/FlkxDMVSbbqRXHH_WT6yZdx4wUgS',
                        desc:'春季皮肤容易过敏，如果购买到劣质产品就更加伤害皮肤，影响身体健康。选择小鱼科学测评的护肤好物，美得安心。',
                        class:'titleclass1',
                        titleclass:'_Titleclass1',
                        productarr:[
                            {
                                
                                class:'class1',
                                desc:'精华液不同于其他护肤品，浓缩了多种功效成分，功能性更强。除了根据肤质和功效需求，更要选择安全优品。',
                                boximg:'bg1',
                                product:[{
                                    img: 'https://p1.fishqc.net/FqMIgcyCiQTa0vqMZgMlRsSp74RP',
                                    brand: "PURID 朴理",
                                    title: '创研修护焕漾精华液<br>(2号精华)',
                                    tips: '抗红御氧',
                                    address: '中国',
                                    type: 'cosmetic',
                                    id: 'uBKKOZ0Ao5UKRKyj9CEC6g',
                          
                                },{
                                    img: 'https://p1.fishqc.net/Fv1z_JMLudtrryPJjrJLSYOI2BTo',
                                    brand: "HELENA RUBINSTEIN",
                                    title: '赫莲娜 至盈抚纹精华液',
                                    tips: '立体抚纹',
                                    address: '法国',
                                    type: 'cosmetic',
                                    id: '4gzuhzJvhN-mF8qNaKY5Gw',
                          
                                },{
                                    img: 'https://p1.fishqc.net/FovUpiF_3RD368DrZN21MT-E-awB',
                                    brand: "LANEIGE兰芝 ",
                                    title: '新水酷高保湿精华露<br>（清润）',
                                    tips: '干皮挚爱',
                                    address: '韩国',
                                    type: 'cosmetic',
                                    id: 'WpTRkHcsA8btsbOWZMoP_w',
                          
                                },{
                                    img: 'https://p1.fishqc.net/Fh5Q6ofRuzProZ9NQ_GbYEqysnSi',
                                    brand: "GRASUS瑰倚丝",
                                    title: '果萃柔肤精华液',
                                    tips: '软化角质',
                                    address: '中国',
                                    type: 'cosmetic',
                                    id: 'g9RkjEhY_8FoisLx5_PO4Q',
                          
                                }]
                            },
                            {
                                
                                class:'class2',
                                desc:'乳液含水量更高，适合夏季及油性皮肤使用。安全乳液优品除了可以清除皮屑污垢，更能补水锁水以及滋养皮肤。',
                                boximg:'bg2',
                                product:[{
                                    img: 'https://p1.fishqc.net/Fgr91JavHqxZ9PWKrq6U4CbYR3co',
                                    brand: "善草纪",
                                    title: '茉莉滢润保湿精华乳',
                                    tips: '嫩滑光泽',
                                    address: '中国',
                                    type: 'cosmetic',
                                    id: 'unISAIvq50vJuofQsWi1ZA',
                                                      
                                },{
                                    img: 'https://p1.fishqc.net/Fn9-XmEFhB3920izi-brdiW87fmr',
                                    brand: "FANCL芳珂",
                                    title: '水盈乳液 - 水润',
                                    tips: '亮泽莹润',
                                    address: '日本',
                                    type: 'cosmetic',
                                    id: '9KWIzrxMVfjMjAoFr4NIeA',
                                                      
                                },{
                                    img: 'https://p1.fishqc.net/FrcHm66ZU-AIVBpBLWTEGBqnmAh1',
                                    brand: "LA ROCHE-POSAY",
                                    title: '理肤泉 特安舒护乳',
                                    tips: '舒缓维稳',
                                    address: '法国',
                                    type: 'cosmetic',
                                    id: 'q1rNjJNT7cFwvJ_-_d2WDQ',
                                                      
                                },{
                                    img: 'https://p1.fishqc.net/FhLBnYatbsDqOEroRaBmm1w_10Gf',
                                    brand: "ALBION奥碧虹",
                                    title: '奥尔滨清新焕白渗透乳<br>(保湿型)',
                                    tips: '滋养弹润',
                                    address: '日本',
                                    type: 'cosmetic',
                                    id: 'MmKWkluKBfcDQLGmMa9gpw',
                                                      
                                }]
                            },
                            {
                                
                                class:'class1',
                                desc:'面霜质地则更为厚重，比较适合冬季及干性皮肤，可以帮助皮肤锁住水分，同时补充营养物质。',
                                boximg:'bg3',
                                product:[{
                                    img: 'https://p1.fishqc.net/FsL5dtBVDMSfOo7naPvYRiS5T165',
                                    brand: "SK-II",
                                    title: '微肌因赋活修护精华霜',
                                    tips: '细腻水润',
                                    address: '日本',
                                    type: 'cosmetic',
                                    id: 'RPp0dZOJ90kPn7FiSpNlMQ', 
                                                      
                                },{
                                    img: 'https://p1.fishqc.net/FhzxA63VwQqKnHryKkmFpSkEEY3b',
                                    brand: "MyClorisLand花皙蔻",
                                    title: '菁纯牡丹抗皱淡纹精华霜',
                                    tips: '紧致淡纹',
                                    address: '日本',
                                    type: 'cosmetic',
                                    id: 'li4ioIgu8L4wYXMSzN4LYA',
                                                      
                                },{
                                    img: 'https://p1.fishqc.net/FjFWIxQaqrjqWbJRmtPaZZ0iuCNM',
                                    brand: "CLARINS娇韵诗",
                                    title: '恒润奇肌保湿凝露',
                                    tips: '多层补水',
                                    address: '法国',
                                    type: 'cosmetic',
                                    id: 'SbH7diI6AIqcvxsQdIK4eQ',
                                                      
                                },{
                                    img: 'https://p1.fishqc.net/Fi5ogn8nfs01S_59061wX8sJae7q',
                                    brand: "CUREL珂润",
                                    title: '淡纹紧致滋养乳霜',
                                    tips: '温和舒缓',
                                    address: '日本',
                                    type: 'cosmetic',
                                    id: '2so1aRbi2EfosWCY8a0aPw',
                                                      
                                }]
                            }
                        ]
    
                    },
                    {
                        titleImg:'https://p1.fishqc.net/FrRmjwBBN9gQQl17BXrq1xyfmrK1',
                        desc:'生活日常用品使用频率高，更要注重安全。选择小鱼科学测评的日用优品，用得放心。',
                        class:'titleclass2',
                        titleclass:'_Titleclass2',
                        
                        productarr:[
                            {
                                
                                class:'class1',
                                desc:'保健品可以及时补充营养需求，调节身体状态，各种通过科学测评的保健品满足你的不同健康需求。',
                                boximg:'bg4',
                                product:[{
                                    img: 'https://p1.fishqc.net/FsOhbEidK-iuofqefY7W8k9BF_y3',
                                    brand: "Doppelherz双心",
                                    title: 'ALL IN ONE',
                                    tips: '全面养护',
                                    address: '德国',
                                    type: 'food',
                                    id: 'sUOufi6j_cK_NwqCK8hI6g',
                                                      
                                },{
                                    img: 'https://p1.fishqc.net/Frvft01Qk750mLq53uXdJnHbKxph',
                                    brand: "FANCL芳珂",
                                    title: '透亮美肌营养素(片剂)',
                                    tips: '亮白光泽',
                                    address: '日本',
                                    type: 'food',
                                    id: '0QT86UqXRI8JN_MhuSjT3Q',
                                                      
                                },{
                                    img: 'https://p1.fishqc.net/Fj6coY1uz6SLQIL1-bEv9utgPMR4',
                                    brand: "SWISSE ULTIBOOST",
                                    title: '维他命 D',
                                    tips: '锁钙入骨',
                                    address: '澳大利亚',
                                    type: 'food',
                                    id: 'wSBCwDwlva8v9AkRVIx8OQ',
                                                      
                                }]
                            },{
                                
                                class:'class1',
                                desc:'疫情后养成了使用湿巾的习惯，劣质湿巾伤害肌肤，更影响身体健康，为了健康更要选择安心的产品。',
                                boximg:'bg5',
                                product:[{
                                    img: 'https://p1.fishqc.net/Fjr3jg-grsNOt6HPwVEoHt6l8h3R',
                                    brand: "NUK",
                                    title: '超厚特柔婴儿湿巾',
                                    tips: '超厚特柔',
                                    address: '德国',
                                    type: 'cosmetic',
                                    id: 'D-gqI-3K4G1ZDGXoEF-TeQ',  
                                                      
                                },{
                                    img: 'https://p1.fishqc.net/Fl5MNhjfnoCj_YjUvb4IKmxCHSwR',
                                    brand: "PIGEON贝亲",
                                    title: '婴儿水润洁肤巾',
                                    tips: '清爽滋润',
                                    address: '日本',
                                    type: 'cosmetic',
                                    id: 'j0uoA0G32vu6eHV1tgJWfA',
                                                      
                                },{
                                    img: 'https://p1.fishqc.net/FhqGxGrYxgr1cLVBolyozXdvDEfu',
                                    brand: "MANNINGS万宁",
                                    title: '抗菌湿巾 (无香味)',
                                    tips: '杀菌清洁',
                                    address: '中国香港',
                                    type: 'cosmetic',
                                    id: 'Mu08gZ5iqJIirxOugaJ2kw',
                                                      
                                }]
                            }
                        ]
    
                    },
                    
                ],
                
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            this.$router.push({
                path: '/product/'+type+'/'+prdid
            })
            
        }
    }
}
</script>